import CountryRegionData from './countryData.json';

export const getCountryFullName = (code) => {
  if (!code) return null;
  const current = CountryRegionData.find(
    (item) => item.countryShortCode === code,
  );
  return current?.countryName;
};
